export default __webpack_public_path__ + "static/media/Armbands of Clawing Might.15181dbd.jpg";